import styled from 'styled-components';
import { StyledIconWrapper } from 'components/new-ui/base/form/styles';

export const ManifestIconWrapper = styled(StyledIconWrapper)`
    width: 20px;
    height: 20px;
    font-size: 12px;

    svg {
        font-size: 12px;
    }
`;

export const SummaryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    width: 100%;
`;

export const SummaryTitleRow = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
`;

export const SummaryReference = styled.span`
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    color: var(--gray-9);
`;

export const SummaryDetailsRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    column-gap: 16px;
    font-size: 12px;
    line-height: 20px;
    color: var(--gray-8);
    white-space: nowrap;
`;

export const SummaryDetail = styled.div`
    display: flex;
    column-gap: 4px;
`;

export const SummaryDetailValue = styled.span`
    font-weight: 600;
`;

export const ManifestDetailsCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 16px;
    padding: 16px;
    border: 1px solid var(--gray-4);
    border-radius: 6px;
`;
